import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Button, Container } from '@mui/material';
import CustomButton from '../CustomButton';
import ApexChart from '../ApexChart';
import Boxes from '../Boxes';
import useWindowDimensions from '../../dimension';
import { useQuery } from 'react-query';
import { fetchHistoricalData } from '../../api/coinmarketcap_api';

import styles from './style.module.css';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  tabsBtn: {
    background: theme.palette.background.tabsBg,
    // border: '1px solid',
    borderColor: theme.palette.border.tabsActiveBorder,
    color: theme.palette.text.light,
    '&:hover': {
      background: theme.palette.background.tabsBg,
    },
    width: 90,
    fontSize: 12,
  },
}));

const CardDouble = ({
  title,
  number,
  avaxPrice,
  noBoxes,
  image,
  btnLabel,
  onClick,
  icon,
  hideHover,
  onChangeTotalRewards, path,
}) => {
  const { width } = useWindowDimensions();
  const [delta, setDelta] = useState(0);
  const [color, setColor] = useState('#FFFFFF');
  const [active, setActive] = useState(1);
  const classes = useStyles();

  const { data: thor } = useQuery('thorData', () => fetchHistoricalData(15789, 'hourly', 24));
  const { data: avax } = useQuery('avaxData', () => fetchHistoricalData(5805, 'hourly', 24));

  const [thorData, setThorData] = useState(null);
  const [avaxData, setAvaxData] = useState(null);

  useEffect(() => {
    setThorData(thor);
  }, [thor]);

  useEffect(() => {
    setAvaxData(avax);
  }, [avax]);

  return (
    <Box
      className={styles.cardWrap}
      sx={{
        width: '100%',
        // height: '268px',
        background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.48)',
        borderRadius: '10px',
        padding: 2,
      }}
    >
      <Grid
        style={{ justifyContent: 'space-between', display: 'flex' }}
        flexDirection={{ xs: 'row', sm: 'column', md: 'row' }}
      >
        <Box style={{ display: 'flex' }}>
          <Box marginLeft={width > 700 ? '10px' : '0px'} marginTop={width > 700 ? '0px' : '0px'}>
            <Typography
              component="div"
              style={{
                color: 'white',
                marginTop: '0',
                marginBottom: '0',
                fontFamily: 'Kanit',
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: width > 700 ? '20px' : '16px',
                lineHeight: '30px',
                opacity: 0.5,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              gutterBottom
              component="div"
              sx={{
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
                fontSize: width > 700 ? '48px' : '40px',
                marginBottom: 0,
              }}
            >
              {number ? number : ''}
            </Typography>
          </Box>
        </Box>
        <Box marginBottom="10px">
          <CustomButton path={path} onClick={onClick} label={btnLabel} fontSize="11px" target="_blank" />
        </Box>
      </Grid>
      {noBoxes ? (
        <Box>
          <Box>
            <Container maxWidth={'xl?'}>
              <Box display={'flex'} justifyContent="space-between">
                <Box display={'flex'} alignItems="center">
                  <Typography
                    variant="body2"
                    component="div"
                    style={{
                      color: 'white',
                      fontFamily: 'Kanit',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      lineHeight: '30px',
                    }}
                  >
                    AVAX
                  </Typography>
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                      fontFamily: 'Kanit',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      textFillColor: 'transparent',
                      fontStyle: 'normal',
                      WebkitTextFillColor: 'transparent',
                      fontWeight: 500,
                      marginLeft: '10px',
                    }}
                  >
                    {avaxPrice ? avaxPrice : ''}
                  </Typography>
                </Box>
                {/* <<<<<<< HEAD */}
                <Box>
                  <Typography
                    variant="body2"
                    component="div"
                    style={{
                      color: color,
                      fontFamily: 'Kanit',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      fontSize: 16,
                      lineHeight: '30px',
                    }}
                  >
                    {delta}
                  </Typography>
                </Box>
              </Box>
            </Container>
          </Box>
          <Box sx={{ height: '96px' }}>
            <ApexChart
              data={active === 1 ? thorData : avaxData}
              onDeltaChange={(delta, color) => {
                setDelta(delta);
                setColor(color);
              }}
            />
          </Box>
          <Box marginTop={0}>
            <Box
              maxWidth={'180px'}
              sx={{
                border: '1px solid #5C5C5C',
                borderRadius: '48px',
                overflow: 'hidden',
                display: 'flex',
                marginX: 'auto',
                height: '24px',
              }}
            >
              <Box flex={1}>
                {active === 1 ? (
                  <Button
                    variant="contained"
                    className={classes.tabsBtn}
                    fullWidth
                    sx={{
                      borderRadius: '0px',
                      paddingTop: '2px !important',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                      fontSize: '12px',
                    }}
                  >
                    THOR
                  </Button>
                ) : (
                  <Button
                    variant="text"
                    fullWidth
                    sx={{
                      color: 'white',
                      fontSize: '12px',
                      paddingTop: '2px !important',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.48)',
                    }}
                    onClick={() => setActive(1)}
                  >
                    THOR
                  </Button>
                )}
              </Box>
              <Box flex={1}>
                {active === 2 ? (
                  <Button
                    className={classes.tabsBtn}
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: '0px',
                      paddingTop: '2px !important',
                      // boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                    }}
                  >
                    AVAX
                  </Button>
                ) : (
                  <Button
                    variant="text"
                    fullWidth
                    sx={{
                      color: 'white',
                      fontSize: '12px',
                      paddingTop: '2px !important',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.48)',
                    }}
                    onClick={() => setActive(2)}
                  >
                    AVAX
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box marginTop={'5px'}>
          <Boxes hideHover={hideHover} onChangeTotalRewards={onChangeTotalRewards} />
        </Box>
      )}
    </Box>
  );
};

export default CardDouble;
